export default __webpack_public_path__ + "static/media/00_delnice-v-lesni-skolce.1968399d.jpg";